<template>
    <div class="title">
        <h1 :class="[size, { 'has-label': hasLabel }]">
            <span v-if="hasCustomTag" :class="['big-tag', getTagClass]">{{ hasCustomTag }}</span>

            <span @click="titleClicked()" v-html="title"
                  @mouseover="showEdit = true" @mouseleave="showEdit = false"
                  :class="[{'clickable-title': !!canEdit}]"></span>
            <i v-if="!!canEdit && showEdit" class="material-icons edit">edit</i>
            <InfoIconWithLabel v-if="hasLabel" :labelInfo="label.labelInfo" :labelPosition="label.labelPosition"/>
        </h1>
    </div>
</template>

<script>
    import InfoIconWithLabel from "../InfoIconWithLabel";
    export default {
        name: "Title",
        components: {InfoIconWithLabel},
        props: ["title", "size", "canEdit", "label", "hasCustomTag"],
        computed: {
            hasLabel() {
                return !!this.label;
            },
            getTagClass() {
                return this.hasCustomTag === 'EU' ? 'big-tag-blue' : 'big-tag-orange';
            }
        },
        data() {
            return {
                showEdit: false
            }
        },
        methods: {
            titleClicked() {
                if (!this.canEdit) return false;

                this.$emit('clicked');
            }
        }
    }
</script>

<style scoped lang="scss">
    .title h1 {
        display: flex;
        align-items: center;
        font-size: 36px;
        line-height: 42px;
        font-weight: normal;
        color: $black-1;

        .big-tag {
            margin-right: 12px;
            padding: 8px 12px;
            height: 36px;
            font-size: 20px;
            line-height: 24px;
            border-radius: 6px;
            color: #fff;
            font-weight: bold;

            &-blue {
                background: $light-blue;
            }

            &-orange {
                background: $orange;
            }
        }

        &.has-label {
            display: flex;
            align-items: center;

            .icon-container {
                margin-left: 4px;
                font-weight: normal;
            }
        }

        &.has-label {
            display: flex;
            align-items: center;

            .icon-container {
                margin-left: 4px;
                font-weight: normal;
            }
        }

        span.clickable-title {
            margin-right: 8px;
            cursor: pointer;
        }

        &.medium {
            margin: 0 0 20px;
            font-size: 28px;
            line-height: 32px;
        }

        &.small {
            margin: 0 0 16px;
            font-size: 18px;
            line-height: 24px;

            &:hover i {
                font-size: 16px;
            }
        }

        &.input-label {
            margin: 0 0 16px;
            font-size: 12px;
            line-height: 16px;
            font-weight: bold;
        }

        &.input-subtext {
            margin-top: -8px;
            font-size: 12px;
            line-height: 16px;
            color: rgba($black-1, .75);
        }

        .edit {
            display: inline-block;
            color: $green;
        }

        &.required {
            position: relative;

            &:after {
                content: '*';
                font-size: 14px;
                line-height: 14px;
                color: $error;
            }
        }
    }
</style>